module.exports = __webpack_public_path__ + "img/Transportationselected.457a2642.jpg";